module.exports = __webpack_public_path__ + "static/Bukola-921c02b997df0752cb63f2ba2c389bd8.png";